import { Button, Separator } from '@chain-zen/ui'

interface IMcLeodSyncSectionProps {
  isSyncing: boolean
  onSyncRequest: () => void
}

/**
 * DFM-only section for syncing active loads from McLeod.
 */
export function McLeodSyncSection({ isSyncing, onSyncRequest }: IMcLeodSyncSectionProps) {
  return (
    <>
      <Separator className="my-4" />
      <div className="space-y-4 text-center w-full">
        <p className="text-sm">
          Fetch all active loads from McLeod and add them to Chain. This is helpful if you had downtime and need to
          resync loads. Note: can only be run once per day
        </p>
        <Button variant="outline" onClick={onSyncRequest} disabled={isSyncing} className="w-full">
          {/* languagetools:disable-next-line */}
          {isSyncing ? 'Requesting sync...' : 'Sync Active Loads'}
        </Button>
      </div>
    </>
  )
}
